import { Flex, Text } from "@mantine/core";
import { ReactNode } from "react";

import ContentWrapper, {
  ContentWrapperProps,
} from "~/components/ContentWrapper";
import SvgIcon from "~/components/SvgIcon";

type Props = ContentWrapperProps & { title: ReactNode; content: ReactNode };

export const WarningSection = ({ title, content, ...props }: Props) => (
  <ContentWrapper direction="row" gap={8} {...props}>
    <SvgIcon name="AlertCircle" strokeWidth={1.67} color="#F79009" />
    <Flex direction="column">
      <Text size="sm" fw={700}>
        {title}
      </Text>
      <Text size="sm">{content}</Text>
    </Flex>
  </ContentWrapper>
);
